import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from '@phosphor-icons/react';

interface PremiumFeatureLockProps {
  featureName: string;
  onUpgrade?: () => void;
  onDismiss?: () => void;
}

export default function PremiumFeatureLock({ featureName, onUpgrade, onDismiss }: PremiumFeatureLockProps) {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      navigate('/settings/subscription');
    }
  };

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#111827] rounded-lg p-6 max-w-md w-full border border-primary">
        <div className="flex items-center justify-center mb-4">
          <Lock size={48} className="text-primary" />
        </div>

        <h2 className="text-white text-xl font-bold text-center mb-2">Your free trial has ended</h2>
        <p className="text-gray-300 text-sm text-center mb-6">
          {featureName} requires an active subscription. Subscribe to a plan to continue learning with educAIte.
        </p>

        <div className="flex gap-3 justify-end">
          {onDismiss && (
            <button
              onClick={handleDismiss}
              className="px-4 py-2 text-gray-400 hover:text-white transition"
            >
              Maybe Later
            </button>
          )}
          <button
            onClick={handleUpgradeClick}
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition"
          >
            Subscribe Now
          </button>
        </div>
      </div>
    </div>
  );
}
